import { reportBrowserTransportError } from '@/monitoring/browserErrors'
import { getMonitorToken, clearMonitorToken } from './storage'
import { attachRequestPage } from '@/api/requestPage'

export const isDeveloperApp = () => window.location.pathname === '/devpensm' || window.location.pathname.startsWith('/devpensm/') || window.location.pathname === '/developer-tools.html'

export function isDeveloperEndpoint(config) {
  const origin = window.location.origin
  const base = new URL(config.baseURL || '/', origin)
  const url = new URL(`${base.pathname.replace(/\/$/, '')}/${(config.url || '').replace(/^\//, '')}`, base)
  if (/^(?:[a-z][a-z0-9+.-]*:)?\/\//i.test(config.url || '') || base.origin !== origin) return false
  return /^\/api\/v1\/(univ\/import(?:\/|$)|admission\/course\/import(?:\/|$)|work\/consulting(?:\/|$)|pendev\/(?:user-anonymization|school-db-status|member-accounts|schools|mail-test)(?:\/|$))/.test(url.pathname)
}

export const isDeveloperSessionExpired = error => error?.response?.status === 401
  && error?.response?.data?.errorCode !== 'PENDEV_AUTH_FAILED'

export function expireDeveloperSession() {
  clearMonitorToken()
  window.location.replace('/devpensm/login')
}

export function installToolInterceptors(instance) {
  instance.interceptors.request.use(config => {
    attachRequestPage(config)
    config.headers = config.headers || {}
    delete config.headers.Authorization
    if (!isDeveloperEndpoint(config)) throw new Error('개발 도구에서 허용하지 않는 API입니다.')
    const token = getMonitorToken()
    const method = (config.method || 'get').toLowerCase()
    const publicConsultingRead = ['get', 'head'].includes(method)
      && /(?:^|\/)work\/consulting\//.test(config.url || '')
      && !/\/consulting\/import(?:\/|$)/.test(config.url || '')
    if (token && !publicConsultingRead) config.headers.Authorization = `Bearer ${token}`
    return config
  })
  instance.interceptors.response.use(response => response, error => {
    reportBrowserTransportError(error)
    // 익명화 쿠키 세션 만료는 개발자 bearer 로그아웃으로 처리하지 않는다.
    const anonymizationSessionMissing = error?.response?.data?.errorCode === 'PENDEV_SESSION_REQUIRED'
    if (isDeveloperSessionExpired(error) && !anonymizationSessionMissing) expireDeveloperSession()
    return Promise.reject(error)
  })
  return instance
}
